"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.required = function () {
    return function (value) {
        return !(value === undefined ||
            value === null ||
            Number.isNaN(value) ||
            value === '');
    };
};
exports.requiredBoolean = function () {
    return function (value) {
        return value === true;
    };
};
